import React from 'react'

const Greet=(props)=>{
  return (
    <div className="Greet" >
  <h1>Welcome to Tic-Tac-Toe!</h1>
    </div>
)}

export default Greet
